import { useContextSelector } from 'use-context-selector';
import { CardsContext } from './CardsContext';
const useCards = () => useContextSelector(CardsContext, state => state.cardListData);

const useIsCorporateCardProvider = () => useContextSelector(CardsContext, state => state.isCorporate);

const useNumberOfCards = () => {
  const context = useContextSelector(CardsContext, state => state.cardListData?.length ?? 0);

  if (context === undefined) {
    throw new Error('useNumberOfCards must be used within CardsProvider');
  }

  return context;
};

const useCardsErrorState = (errorProperty: 'cardListDataError') => {
  const context = useContextSelector(CardsContext, state => state.errorState);

  if (context === undefined) {
    throw new Error('useCardsErrorState must be used within CardsProvider');
  }

  return context[errorProperty];
};

const useCardsLoadingState = (loadingProperty: 'isLoadingCardListData') => {
  const context = useContextSelector(CardsContext, state => state.loadingState);

  if (context === undefined) {
    throw new Error('useCardsLoadingState must be used within CardsProvider');
  }

  return context[loadingProperty];
};

const useOnSetPopularCards = () => {
  const context = useContextSelector(CardsContext, state => state.onSetPopularCards);

  if (context === undefined) {
    throw new Error('useOnSetPopularCards must be used within AccountsProvider');
  }

  return context;
};

const useOnSetPagination = () => {
  const context = useContextSelector(CardsContext, state => state.onSetPagination);

  if (context === undefined) {
    throw new Error('useOnSetPagination must be used within CardsProvider');
  }

  return context;
};

const usePagination = () => {
  const context = useContextSelector(CardsContext, state => state.pagination);

  if (context === undefined) {
    throw new Error('usePagination must be used within CardsProvider');
  }

  return context;
};

const useRefetchCardsListMutation = () => {
  const context = useContextSelector(CardsContext, state => state.refetchCardsDataMutation);

  if (context === undefined) {
    throw new Error('useRefetchCardsListMutation must be used within CardsProvider');
  }

  return context;
};

const useCardsListFilters = () => {
  const context = useContextSelector(CardsContext, state => state.cardsListFilters);

  if (context === undefined) {
    throw new Error('useCardsListFilters must be used within CardsProvider');
  }

  return context;
};

const useOnCardsListFiltersChange = () => {
  const context = useContextSelector(CardsContext, state => state.onCardsListFiltersChange);

  if (context === undefined) {
    throw new Error('useOnCardsListFiltersChange must be used within CardsProvider');
  }

  return context;
};

export {
  useCards,
  useIsCorporateCardProvider,
  useNumberOfCards,
  useCardsErrorState,
  useCardsLoadingState,
  useOnSetPopularCards,
  useOnSetPagination,
  usePagination,
  useRefetchCardsListMutation,
  useCardsListFilters,
  useOnCardsListFiltersChange,
};
